import React, { useCallback, useRef, useState, useEffect } from "react";
import { connect } from "react-redux";

import {
    Column,
    DataGrid,
    GroupPanel,
    Scrolling,
    Grouping,
    FilterRow,
    FilterPanel,
    Sorting,
    Paging,
    Editing,
    Export,
    Pager,
    ColumnChooser,
    StateStoring,
    Selection,
    Lookup,
    Toolbar,
    Item,
    RequiredRule,
    Summary,
    TotalItem
} from "devextreme-react/data-grid";
import DataSource from "devextreme/data/data_source";
import { createStore } from 'devextreme-aspnet-data-nojquery';
import { confirm } from 'devextreme/ui/dialog';

import "../../../../css/omstyle.css";
import notify from 'devextreme/ui/notify';
import { Button, SelectBox } from 'devextreme-react';

import axios from "axios";
import routes from "../../../../../assets/apiRoutes.json";
import { MESSAGES } from "../../../../../common/Messages";
import RenderSelectBoxCell from "../../../../../common/RenderCell";


const RetainersTab = (props) => {
    const dataGrid = useRef(null);
    const dataSource = createStore({
        key: 'RowId',
        loadUrl: `${window._env_.REACT_APP_APIS}/${routes.AR.GetRetainers}`,
        insertUrl: `${window._env_.REACT_APP_APIS}/${routes.AR.AddRetainer}`,
        updateUrl: `${window._env_.REACT_APP_APIS}/${routes.AR.EditRetainer}`,
        loadParams: {
            sourceId: props.formFields.ROWID
        },
        onBeforeSend: function (method, ajaxOptions) {
            ajaxOptions.headers = {
                Authorization: `Bearer ${accessToken}`,
                Key: props.formFields.ROWID,
            };
        }

    });

    var accessToken = props.oidc.user.access_token;
    const [selectedItemKeys, setSelectedItemKeys] = useState([]);
    const handleCellValueChanged = (data) => {
        setSelectedItemKeys(data.selectedRowKeys);
    }

    const deleteRecords = useCallback(() => {
        let result = confirm(`<i>${MESSAGES.DELETE_CONFIRM}</i>`, "Delete");
        result.then((dialogResult) => {
            if (dialogResult) {
                dataGrid.current.instance().beginCustomLoading("Deleting");
                axios.post
                    (
                        `${window._env_.REACT_APP_APIS}/${routes.AR.Delete}`,
                        selectedItemKeys[0],
                        {
                            headers: {
                                "Content-Type": "application/json",
                                access_token: accessToken,
                            },
                        }
                    )
                    .then((res) => {
                        dataGrid.current.instance().endCustomLoading();
                        dataGrid.current.instance().refresh();
                    })
                    .catch((err) => {
                        dataGrid.current.instance().endCustomLoading();
                        alert(err, "Error");
                    });

            }
        });

    }, [selectedItemKeys]);
    const onContentReady = async (e) => {
        if (!e.component._hasLoaded) {
            e.component._hasLoaded = true;
            e.component.option("dataSource", dataSource);
        }
    }
    const onRowInserting = (e) => {
        e.data.RSourceid = props.formFields.ROWID;
    };
    const onCellClick = (e) => {
        if (e.rowType === "data" && e.data.RowId) {
            e.component.selectRows([e.data.RowId], false);
        }
    };
    const onInitNewRow = (e) => {
        e.data.TransactionNumber = (props.formFields.TRANSACTIONNUMBER||'').trim() + '-';
    }
    const calculateCustomSummary = useCallback((options) => {
        if (options.name === "positiveSum") {
            if (options.summaryProcess === "start") {
                options.totalValue = 0;
            }
            if (options.summaryProcess === "calculate") {
                // add only positive Amounts
                if ((options.value.Amount ?? 0) > 0) {
                    options.totalValue += options.value.Amount;
                }
            }
            if (options.summaryProcess === "finalize") {
                const totalAmount = props.selectedTotals?.totalAmount?.toFixed(2) ?? 0;
                options.totalValue = totalAmount - options.totalValue;
            }
        }
                if (options.name === "dueBalance") {
            if (options.summaryProcess === "start") {
                options.totalValue = 0;
            }
            if (options.summaryProcess === "finalize") {
                options.totalValue = props.selectedTotals?.totalAmount?.toFixed(2);
            }
        }
        
    }, []);
    return (
        <div>
            
            <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                onContentReady={onContentReady}
                ref={dataGrid}
                selectedRowKeys={selectedItemKeys}
                showBorders={true}
                onSelectionChanged={handleCellValueChanged}
                onRowInserting={onRowInserting}
                onCellClick={onCellClick}
                onInitNewRow={onInitNewRow}
                rowAlternationEnabled={true}
                allowColumnReordering={true}
                allowColumnResizing={true}
                columnAutoWidth={true}
                height='80vh'
            >
                <Scrolling mode="standard" />
                <Selection mode="single" />
                <Export enabled={true} allowExportSelectedData={true} />
                <Sorting visible={true} mode="multiple" />
                <Editing
                    mode="cell"
                    allowUpdating={true}
                    allowAdding={true}
                />
                <FilterRow visible={true} />
                <Column dataType="string" dataField="TransactionNumber" caption="Transaction #" />
                <Column dataType="date" dataField="TransactionDate" caption="Due Date" />
                <Column dataType="string" dataField="Distribution" caption="Distribution" editCellRender={(cellElement) =>
                    RenderSelectBoxCell({
                        loadParams: {
                            lookupType: function () {
                                return "Distribution";
                            },
                            module: function () {
                                return "AC";
                            },
                            usageModule: function () {
                                return "R"
                            },
                            isPascalCase: function () {
                                return true;
                            }
                        },
                        loadUrl: `${window._env_.REACT_APP_APIS}/${routes.Common.GetLookup}`,
                        key: "Id",
                        displayExpr: "Name",
                        valueExpr: "Id",
                        accessToken: accessToken,
                        defaultValue: cellElement.data.RACDistribution,
                        sort: [{ selector: "Name", desc: false }],
                        onValueChangeCallback: (value, text) => {
                            cellElement.setValue(({ value, text }));
                        },
                    })
                }
                    setCellValue={(rowData, newValue) => {
                        rowData.Distribution = newValue.text;
                        rowData.RACDistribution = newValue.value;
                    }} />
                <Column dataType="string" dataField="Account" caption="Account" editCellRender={(cellElement) =>
                    RenderSelectBoxCell({
                        loadParams: {
                            lookupType: function () {
                                return "ACAccount";
                            },
                            module: function () {
                                return "AC";
                            },
                            accountType: function () {
                                return "D";
                            },
                            isPascalCase: function () {
                                return true;
                            }
                        },
                        loadUrl: `${window._env_.REACT_APP_APIS}/${routes.Common.GetLookup}`,
                        key: "Id",
                        displayExpr: "Name",
                        valueExpr: "Id",
                        accessToken: accessToken,
                        defaultValue: cellElement.data.RGlAccount,
                        sort: [{ selector: "Name", desc: false }],
                        onValueChangeCallback: (value, text) => {
                            cellElement.setValue(({ value, text }));
                        },
                    })
                }
                    setCellValue={(rowData, newValue) => {
                        rowData.Account = newValue.text;
                        rowData.RGlAccount = newValue.value;
                    }} />
                <Column dataType="string" dataField="Department" caption="Department" editCellRender={(cellElement) =>
                    RenderSelectBoxCell({
                        loadParams: {
                            lookupType: function () {
                                return "ACDepartments";
                            },
                            module: function () {
                                return "AC";
                            },
                            isPascalCase: function () {
                                return true;
                            }
                        },
                        loadUrl: `${window._env_.REACT_APP_APIS}/${routes.Common.GetLookup}`,
                        key: "Id",
                        displayExpr: "Department",
                        valueExpr: "Id",
                        accessToken: accessToken,
                        defaultValue: cellElement.data.RGlDepartment,
                        sort: [{ selector: "Department", desc: false }],
                        onValueChangeCallback: (value, text) => {
                            cellElement.setValue(({ value, text }));
                        },
                    })
                }
                    setCellValue={(rowData, newValue) => {
                        rowData.Department = newValue.text;
                        rowData.RGlDepartment = newValue.value;
                    }} />
                <Column dataType="string" dataField="Fund" caption="Fund" editCellRender={(cellElement) =>
                    RenderSelectBoxCell({
                        loadParams: {
                            lookupType: function () {
                                return "FAFunds";
                            },
                            module: function () {
                                return "FA";
                            },
                            isPascalCase: function () {
                                return true;
                            }
                        },
                        loadUrl: `${window._env_.REACT_APP_APIS}/${routes.Common.GetLookup}`,
                        key: "Id",
                        displayExpr: "Fund",
                        valueExpr: "Id",
                        accessToken: accessToken,
                        defaultValue: cellElement.data.RGlFund,
                        sort: [{ selector: "Fund", desc: false }],
                        onValueChangeCallback: (value, text) => {
                            cellElement.setValue(({ value, text }));
                        },
                    })
                }
                    setCellValue={(rowData, newValue) => {
                        rowData.Fund = newValue.text;
                        rowData.RGlFund = newValue.value;
                    }} />
                <Column dataType="string" dataField="Job" caption="Job" editCellRender={(cellElement) =>
                    RenderSelectBoxCell({
                        loadParams: {
                            lookupType: function () {
                                return "CAJobs";
                            },
                            module: function () {
                                return "CA";
                            },
                            isPascalCase: function () {
                                return true;
                            }
                        },
                        loadUrl: `${window._env_.REACT_APP_APIS}/${routes.Common.GetLookup}`,
                        key: "Id",
                        displayExpr: "Job",
                        valueExpr: "Id",
                        accessToken: accessToken,
                        defaultValue: cellElement.data.RCaJob,
                        sort: [{ selector: "Job", desc: false }],
                        onValueChangeCallback: (value, text) => {
                            cellElement.setValue(({ value, text }));
                        },
                    })
                }
                    setCellValue={(rowData, newValue) => {
                        rowData.Job = newValue.text;
                        rowData.RCaJob = newValue.value;
                    }} />
                <Column dataType="string" dataField="Activity" caption="Activity" editCellRender={(cellElement) =>
                    RenderSelectBoxCell({
                        loadParams: {
                            lookupType: function () {
                                return "CAActivity";
                            },
                            module: function () {
                                return "CA";
                            },
                            type: function () {
                                return "D";
                            },
                            isPascalCase: function () {
                                return true;
                            }
                        },
                        loadUrl: `${window._env_.REACT_APP_APIS}/${routes.Common.GetLookup}`,
                        key: "Id",
                        displayExpr: "Name",
                        valueExpr: "Id",
                        accessToken: accessToken,
                        defaultValue: cellElement.data.RCaActivity,
                        sort: [{ selector: "Name", desc: false }],
                        onValueChangeCallback: (value, text) => {
                            cellElement.setValue(({ value, text }));
                        },
                    })
                }
                    setCellValue={(rowData, newValue) => {
                        rowData.Activity = newValue.text;
                        rowData.RCaActivity = newValue.value;
                    }} />
                <Column dataType="number" dataField="Amount" caption="Amount" format={{
                    type: 'currency',
                    precision: 2,
                    currency: 'USD',
                    useGrouping: true
                }} >
                    <RequiredRule message={MESSAGES.REQUIRED}></RequiredRule>
                </Column>
                <Column dataType="number" dataField="RetainerPaymentAmount" caption="PaymentAmount" allowEditing={false} format={{
                    type: 'currency',
                    precision: 2,
                    currency: 'USD',
                    useGrouping: true
                }} />
                <Column dataType="number" dataField="RetainerBalance" caption="Balance" allowEditing={false} format={{
                    type: 'currency',
                    precision: 2,
                    currency: 'USD',
                    useGrouping: true
                }} />
                <Column dataType="number" dataField="RetainerLastReceivedDate" caption="Last Received Date" allowEditing={false} format={{
                    type: 'currency',
                    precision: 2,
                    currency: 'USD',
                    useGrouping: true
                }} />
                <Column dataType="string" dataField="Description" caption="Description" />
                <Summary calculateCustomSummary={calculateCustomSummary}>
                    <TotalItem
                        name="positiveSum"
                        showInColumn="Amount"
                        summaryType="custom"
                        displayFormat="Amount Due: {0}"
                        valueFormat="#,##0.00"
                    />
                    <TotalItem
                        name="dueBalance"
                        showInColumn="RetainerBalance"
                        summaryType="custom"
                        displayFormat="Balance Due: {0}"
                        valueFormat="#,##0.00"
                    />
                </Summary>
                <Toolbar>
                    <Item
                        name="addRowButton"
                    />
                    <Item location="after">
                        <Button
                            onClick={deleteRecords}
                            icon="trash"
                            disabled={!selectedItemKeys.length}
                        />
                    </Item>
                </Toolbar>
            </DataGrid>
        </div>
    );
};
function mapStateToProps(state) {
    return {
        oidc: state.oidc,
        ReceiptReducer: state.ReceiptReducer,
    };
}
export default connect(mapStateToProps)(RetainersTab);